import { Box } from '@mui/material';
import React, { useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';

const BlogSoft = () => {

    const RecentBlog = [
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '4 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-2.png',
            title: 'The Power of Smart Warehouse Management System in 2024',
            date: '23 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-3.png',
            title: 'Is slower team communication a bad thing?',
            date: '14 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '8 March 2024',
            path: '/blog-detail'
        },
    ]

    const blogTag = [
        {
            tagTitle: 'Development',
            path: '/DevelopBlogList'
        },
        {
            tagTitle: 'Technology',
            path: '/TechBlogList'
        },
        {
            tagTitle: 'HTML',
            path: '/HtmlBlogList'
        },
        {
            tagTitle: 'Branding',
            path: '/BrandBlogList'
        },
        {
            tagTitle: 'PHP',
            path: '/PhpBlogList'
        }
    ]

    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate(); // Hook for programmatic navigation

    // Handle the search input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle form submission (search on Enter key press)
    const handleSearchSubmit = (e) => {
        e.preventDefault();

        // Filter the tags based on the search query
        const filteredTags = blogTag.filter((tag) =>
            tag.tagTitle.toLowerCase().includes(searchQuery.toLowerCase())
        );

        const filteredBlogs = RecentBlog.filter((blog) =>
            blog.title.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Navigate to the search results page with the filtered data
        navigate('/noBlog', {
            state: { searchQuery, filteredTags, filteredBlogs },
        });
    };

    return (
        <>
                
            {/* Blog Detail Banner */}
            <section className='blog-detail-page'>
                <div className='blog-detail-bg'>    
                    <div className='c-detail-shap-1  blog-det-1'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='blog-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-2.svg" alt="" />
                    </div>
                    <div className='about-shap-3 blog-det-1'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4 blog-det-1'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 blog-det-1'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <div className='row justify-content-center'>
                            <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11 col-padding'>
                                <div className='blogdetail-content' data-aos="fade-right" data-aos-duration="2000">
                                    <h3>How Custom Software Development Empowers Businesses </h3>
                                    <h6>18 Feb 2025</h6>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
        
            <div className='blog-detail-position'>
                <Container>
                    <div className='row justify-content-center'>
                        <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11' data-aos="zoom-in-up" data-aos-duration="2500">
                            <div className='blog-detail-1'>
                                <img src="../assets/images/blog_4.png" alt="" />
                            </div>
                        </div>
                    </div>

                    <div className='blog-detail-padding'>
                        <Row>
                            <div className="col-xl-8 col-lg-7">

                                <p className='blog-para'>Off-the-shelf solutions are often a good starting point, but they rarely align perfectly with every organization’s unique needs. That’s where custom software development comes in. Tailored software can solve very specific business challenges and scale alongside your operations.  </p>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1500">
                                    <h3>Tailored to Your Workflow </h3>
                                    <p>Unlike generic tools, custom software is built around how your team actually works. It can automate repetitive tasks, integrate with your existing systems, and be modified as your business evolves. This improves productivity and reduces bottlenecks. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1650">
                                    <h3>Enhanced Security and Control </h3>
                                    <p>With custom solutions, you control how data is handled, stored, and protected. This is particularly important for industries like finance, healthcare, and logistics, where data compliance and privacy are critical. You’re not limited by the security vulnerabilities of a third-party product. </p>
                                </div>
                                
                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1800">
                                    <h3>Competitive Advantage </h3>
                                    <p>Custom-built software allows businesses to innovate faster and deliver unique value. It reflects your brand, solves niche problems, and can be continuously improved based on user feedback. This agility gives you an edge over competitors relying on one-size-fits-all platforms. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1950">
                                    <h3>Long-Term Cost Efficiency </h3>
                                    <p>While initial development costs can be higher, custom software often pays off in the long run. There are no recurring license fees, fewer workarounds, and less reliance on external vendors for updates and integrations. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2100">
                                    <h3>Scalability and Flexibility </h3>
                                    <p>As your business grows, your software should grow with it. Custom solutions can be adapted to meet new demands, whether that’s handling more users, integrating with new platforms, or adding features. </p>

                                    <p>By investing in custom software, you’re not just buying a tool—you’re building a long-term digital asset that evolves with your business goals and supports continuous innovation. </p>
                                </div>

                            </div>
                            <div className="col-xl-4 col-lg-5 mt-30">
                                <div className='ml-lg-30 ml-0'>
                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="3000">
                                        <div className='search-border'>
                                            <h4>Search</h4>
                                            <form className='search-box position-relative' onSubmit={handleSearchSubmit}>
                                                <input className='w-100' placeholder='Search Your Keywords…' type="text" value={searchQuery}  onChange={handleSearchChange} />
                                                <button className='search-icon' type="submit">
                                                    <img src="../assets/images/search-icon.svg" alt="" />
                                                </button>
                                            </form>
                                        </div>
                                    </div>


                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="2500">
                                        <div className='blog-border'>
                                            <h4>Recent Blog</h4>
                                            <div className='border-blog'></div>
                                            <ul>
                                                {RecentBlog.map((blog, index) => (
                                                    <li key={index}>
                                                        <Link to={blog.path}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '13px'
                                                            }}>
                                                                <div className='blog-list-img'>
                                                                    <img src={blog.img} alt="" />
                                                                </div>
                                                                <div className='blog-list-text'>
                                                                    <h6>{blog.title}</h6>
                                                                    <p>{blog.date}</p>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='blog-border' data-aos="fade-up-left" data-aos-duration="2000">
                                        <h4>Tag Cloud</h4>
                                        <div className='border-blog'></div>
                                        
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '10px'
                                        }}>
                                            {
                                                blogTag.map((tag,index) => (
                                                    <Link key={index} to={tag.path}>
                                                        <p className="tag-badge">{tag.tagTitle}</p>
                                                    </Link>
                                                ))
                                            }
                                        </Box>
                                        
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>
                </Container>
            </div>
        
        </>
    )
}

export default BlogSoft
